import config from '../config'; // Adjust the import path
import { v4 as uuidv4 } from 'uuid';


const R2_AUTH_TOKEN = config.REACT_APP_R2_AUTH_TOKEN
const WORKER_URL =  config.WORKER_BASE_URL
const R2_GET_URL = 'https://server.fitplannerhub.org/api/file';

/**
 * Upload a training file to R2 bucket
 */
export const uploadTrainingToR2 = async (training, fitnessCenterId, file) => {
  const randomName = uuidv4();
  const key = `trainings/center/${fitnessCenterId}/client/${training.client.id}/${training.numberOfTrainings}/${randomName}`;

  const reader = new FileReader();

  return new Promise((resolve, reject) => {
    reader.onload = async () => {
      const base64 = (reader.result as string).split(',')[1];

      try {
        const res = await fetch(WORKER_URL, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${R2_AUTH_TOKEN}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            filename: key,
            fileContent: base64,
          })
        });

        if (!res.ok) throw new Error('Upload failed');
        const data = await res.json();
        console.log('File uploaded successfully', data);
        resolve(`${WORKER_URL}/${key}`);
      } catch (err) {
        console.error('File upload error', err);
        reject(err);
      }
    };

    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};


/**
 * Get direct download URL from R2
 */
export const getFileUrl = (key) => {
  return `${WORKER_URL}/${key}`;
};
